import Settings from "@/constants/Settings";
import dictEnum from "@/constants/SysMsgDict";
import { datePickerLang } from "@/constants/globalConstants";
import ArrayHelper from "@/common/helper/ArrayHelper";
import moment from "moment";
import images from "@/constants/image";

export const GlobalMixin = {
    Settings: Settings,
    dictEnum: dictEnum,
    lang: datePickerLang,
    moment: moment,
    ArrayHelper: ArrayHelper,
};

export const minxin = {
    data() {
        return GlobalMixin
    }
}



// WEBPACK FOOTER //
// ./src/common/mixin/GlobalMixin.js